export const LEARNING_PORTFOLIO_FEATURE_KEY = 'learning-portfolio';
